import React from 'react';
import { SlideContainer } from './SlideContainer';
import slideContatoImg from '../assets/SlideContato.jpg';
import whatsappIconImg from '../assets/whatsapp.png';
import { ISlidePropostaData } from '../interface';
import { getUsuario } from '../../../services/token/usuario';
import { formatPhoneNumber } from '../../../utils/MascaraDeCampos';

export interface SlideContatoProps {
  data?: ISlidePropostaData;
  scale?: number;
}

const WhatsAppIcon: React.FC<{ size?: number }> = ({ size = 26 }) => (
  <img
    src={whatsappIconImg}
    alt="WhatsApp"
    width={size}
    height={size}
    style={{
      verticalAlign: 'middle',
      display: 'inline-block',
      marginLeft: '8px',
      flexShrink: 0,
      objectFit: 'contain',
    }}
  />
);

export const SlideContato: React.FC<SlideContatoProps> = ({ data, scale = 1 }) => {
  const loggedUser = getUsuario();

  const principalNome = data?.contato_principal_nome || '';
  const principalCargo = data?.contato_principal_cargo || '';
  const principalPhone = data?.contato_principal_telefone || '';
  const principalEmail = data?.contato_principal_email || '';

  const vendedorNome = data?.vendedor_nome || loggedUser?.nome || '';
  const vendedorCargo = data?.vendedor_cargo || (typeof loggedUser?.cargo === 'object' ? loggedUser?.cargo?.nome : '') || '';
  const vendedorPhone = data?.vendedor_telefone || loggedUser?.celular || '';
  const vendedorEmail = data?.vendedor_email || loggedUser?.email || '';

  const isSamePerson = Boolean(
    vendedorNome &&
    principalNome &&
    vendedorNome.trim().toLowerCase() === principalNome.trim().toLowerCase()
  );

  return (
    <SlideContainer
      showFooterLogo={false}
      showWaves={false}
      noPadding={true}
      backgroundImage={slideContatoImg}
      scale={scale}
      data={data}
    >
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <div
          style={{
            position: 'absolute',
            top: '18%',
            left: '9%',
            width: '46%',
            color: '#1a1a1a',
            fontSize: '1.5rem',
            lineHeight: 1.45,
            textAlign: 'left'
          }}
        >
          {/* Dados da Empresa */}
          <p style={{ margin: '0 0 1.1em 0' }}>
            <strong style={{ fontWeight: 'bold' }}>
              GOVFÁCIL GESTÃO & TECNOLOGIA LTDA.
            </strong>
            <br />
            CNPJ 41.886.613/0001-55
            <br />
            <strong style={{ fontWeight: 'bold' }}>
              aplicativo.govfacil@gmail.com
            </strong>
          </p>

          {/* Contato Principal / Diretoria */}
          {principalNome && (
            <div style={{ marginBottom: '1.1em' }}>
              <div style={{ fontWeight: 'bold' }}>{principalNome}</div>
              {principalCargo && (
                <div style={{ fontSize: '0.90em', color: '#444' }}>
                  {principalCargo}
                </div>
              )}
              {principalPhone && (
                <div style={{ display: 'inline-flex', alignItems: 'center', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  <span>{formatPhoneNumber(principalPhone, false)}</span>
                  <WhatsAppIcon size={26} />
                </div>
              )}
            </div>
          )}

          {/* Consultor/Vendedor Responsável */}
          {vendedorNome && !isSamePerson && (
            <div style={{ marginBottom: '1.1em' }}>
              <div style={{ fontWeight: 'bold' }}>{vendedorNome}</div>
              {vendedorCargo && (
                <div style={{ fontSize: '0.90em', color: '#444' }}>
                  {vendedorCargo}
                </div>
              )}
              {vendedorPhone && (
                <div style={{ display: 'inline-flex', alignItems: 'center', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  <span>{formatPhoneNumber(vendedorPhone, false)}</span>
                  <WhatsAppIcon size={26} />
                </div>
              )}
            </div>
          )}

          {/* Endereço */}
          <p style={{ margin: 0 }}>
            <strong style={{ fontWeight: 'bold' }}>
              Rua Fernando de Noronha, 956 Sala 41
            </strong>
            <br />
            Centro - Londrina – PR
            <br />
            CEP: 86.060-410
          </p>
        </div>
      </div>
    </SlideContainer>
  );
};